import React from 'react';
import { Truck } from 'lucide-react';
export function ShippingBanner() {
  return <div className="bg-[#5C3D2E] text-white py-3" data-id="element-407">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
        <div className="flex items-center justify-center gap-2 text-sm sm:text-base font-['Raleway'] tracking-wide" data-id="element-409">
          <Truck size={16} strokeWidth={1.5} className="text-[#D4A853]" data-id="element-410" />
          <span data-id="element-411">
            Free shipping on orders over{' '}
            <span className="text-[#D4A853] font-medium" data-id="element-412">$75</span>
            <span className="hidden sm:inline text-white/60 ml-2" data-id="element-413">
              · For Africans, By an African
            </span>
          </span>
        </div>
      </div>
    </div>;
}